export const UPDATE_BILLING_SUMMARY = 'UPDATE_BILLING_SUMMARY';
export const UPDATE_DELIVERY_ADDRESS = 'UPDATE_DELIVERY_ADDRESS';
export const UPDATE_DELIVERY_SCHEDULE = 'UPDATE_DELIVERY_SCHEDULE';
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const UPDATE_PAYMENT_INTENT = 'UPDATE_PAYMENT_INTENT';
export const UPDATE_PAYMENT_ORDER = 'UPDATE_PAYMENT_ORDER';
